import { FinanceSearchField } from '@common/enums/financeSearchField';
import { isNonNullable } from '@common/utils/nonNullableTypeUtils';
import { normalizeSearchText } from '@common/utils/normalizeSearchText';

export function isAtLeastOneFilterSelected(filters: object) {
    return Object.values(filters).some((value) => isNonNullable(value));
}

export function constructSearchForFilter(searchText: string | undefined, searchField: FinanceSearchField | undefined) {
    return {
        searchField,
        searchText:
            searchText && searchField === FinanceSearchField.processNumber
                ? normalizeSearchText(searchText)
                : searchText,
    };
}
